/*
  SMA Gallery Nav
  Desktop-only prev / next chevrons for the main product media viewer.
  Steps the active media one item at a time by reusing <media-gallery>'s own
  setActiveMedia(), so thumbnails, the live region and video playback all stay
  in sync. Greys itself out on the first / last image and hides when there is
  only one media item. The markup is rendered by 'product-media-gallery'.
*/
if (!customElements.get('sma-gallery-nav')) {
  customElements.define(
    'sma-gallery-nav',
    class SmaGalleryNav extends HTMLElement {
      connectedCallback() {
        this.gallery = this.closest('media-gallery');
        this.prevButton = this.querySelector('[data-sma-gallery-prev]');
        this.nextButton = this.querySelector('[data-sma-gallery-next]');
        if (!this.gallery || !this.prevButton || !this.nextButton) return;

        this.viewer = this.gallery.querySelector('[id^="GalleryViewer"]');
        this.list = this.gallery.querySelector('[id^="Slider-Gallery"]');
        if (!this.viewer || !this.list) return;

        this.onPrevClick = this.step.bind(this, -1);
        this.onNextClick = this.step.bind(this, 1);
        this.prevButton.addEventListener('click', this.onPrevClick);
        this.nextButton.addEventListener('click', this.onNextClick);

        // Keeps the arrows in step with thumbnail clicks and variant changes.
        this.observer = new MutationObserver(this.syncButtons.bind(this));
        this.observer.observe(this.viewer, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class'],
        });

        this.syncButtons();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
        if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
      }

      // Only the <li> slides — the media wrapper inside each slide carries a
      // data-media-id of its own, so a plain querySelectorAll doubles the count.
      get items() {
        return Array.from(this.list.children).filter((item) => item.dataset.mediaId);
      }

      activeIndex(items) {
        const index = items.findIndex((item) => item.classList.contains('is-active'));
        return index < 0 ? 0 : index;
      }

      step(direction) {
        const items = this.items;
        if (items.length < 2) return;

        const target = this.activeIndex(items) + direction;
        if (target < 0 || target > items.length - 1) return;

        if (typeof this.gallery.setActiveMedia === 'function') {
          this.gallery.setActiveMedia(items[target].dataset.mediaId, false);
        }

        this.syncButtons();
      }

      syncButtons() {
        const items = this.items;
        const index = this.activeIndex(items);

        this.toggleAttribute('hidden', items.length < 2);
        this.prevButton.disabled = index <= 0;
        this.nextButton.disabled = items.length === 0 || index >= items.length - 1;
      }
    }
  );
}
